// export const DEFINED_PERMISSIONS = {
//   VendorCreate: "VendorCreate",
//   AssetView: "AssetView",
//   //=========================================
//   Request_Asset: "Request_Asset",
//   Vendor: "Vendor",
//   SeniorVendorManager: "SeniorVendorManager",
//   PrimaryVendorManager: "PrimaryVendorManager",
//   ProcurementApproval: "ProcurementApproval",
//   ProcurementRequisitionApproval: "ProcurementRequisitionApproval",
//   QuotationApproval: "QuotationApprove",
//   VendorManager: "VendorManager",
//   VendorApproval: "VendorApproval",
//   AssetAdd: "AssetAdd",
//   AssetApproval: "AssetApproval",
//   Auditor: "Auditor",
//   PermissionManager: "PermissionManager",
//   SecondaryVendorManager: "SecondaryVendorManager",
//   UserCreation: "UserCreation",
//   AssetAcquisitionView: "AssetAcquisitionView",
//   AssetAcquisitionAdd: "AssetAcquisitionAdd",
//   AssetAcquisitionApprove: "AssetAcquisitionApprove",
//   AssetAllocationAdd: "AssetAllocationAdd",
//   AssetAllocationApprove: "AssetAllocationApprove",
//   AssetAllocationView: "AssetAllocationView",
//   AssetAuctionApprove: "AssetAuctionApprove",
//   AssetAuctionAdd: "AssetAuctionAdd",
//   AssetAuctionView: "AssetAuctionView",
//   AssetBidView: "AssetBidView",
//   AssetBidAdd: "AssetBidAdd",
//   AssetBidApprove: "AssetBidApprove",
//   AssetCategoryAdd: "AssetCategoryAdd",
//   AssetCategoryApprove: "AssetCategoryApprove",
//   AssetCategoryView: "AssetCategoryView",
//   AssetComponentAdd: "AssetComponentAdd",
//   AssetComponentView: "AssetComponentView",
//   AssetMantainanceView: "AssetMantainanceView",
//   AssetMaintainanceApproval: "AssetMaintainanceApproval",
//   AssetMantainanceAdd: "AssetMantainanceAdd",
//   AssetRequisitionApprove: "AssetRequisitionApprove",
//   AssetRequisitionAdd: "AssetRequisitionAdd",
//   AssetRequisitionView: "AssetRequisitionView",
//   BudgetAdd: "BudgetAdd",
//   BudgetView: "BudgetView",
//   ConsumableView: "ConsumableView",
//   ConsumableApprove: "ConsumableApprove",
//   ConsumableAdd: "ConsumableAdd",
//   ConsumableAllocationApprove: "ConsumableAllocationApprove",
//   ConsumableAllocationAdd: "ConsumableAllocationAdd",
//   ConsumableAllocationView: "ConsumableAllocationView",
//   ConsumableRequisitionView: "ConsumableRequisitionView",
//   ConsumableRequisitionApprove: "ConsumableRequisitionApprove",
//   ConsumableRequisitionAdd: "ConsumableRequisitionAdd",
//   ConsumableCategoryView: "ConsumableCategoryView",
//   ConsumableCategoryApprove: "ConsumableCategoryView",
//   ConsumableCategoryAdd: "ConsumableCategoryAdd",
//   BusinessNature: "BusinessNature",
//   SeniorProcurementManager: "SeniorProcurementManager",
// DeliveryView:"DeliveryView",
// DeliveryApprove:"DeliveryApprove",
// DeliveryConfirm:"DeliveryConfirm",
// DeliveryRating:"DeliveryRating",
// AddDeliveryNote:"AddDeliveryNote",
//   PrimaryProcurementManager: "PrimaryProcurementManager",
//   ProcurementRequisitionView: "ProcurementRequisitionView",
//   ProcurementRequisitionAdd: "ProcurementRequisitionAdd",
//   ProcurementRequisitionDashboard: "ProcurementRequisitionDashboard",
//   QuotationDeliver: "QuotationDeliver",
//   // QuotationView: "QuotationView",
//   QuotationAdd: "QuotationAdd",
//   DeliveryView: "DeliveryView",
//   DeliveryApprove: "DeliveryApprove",
//   DeliveryConfirm: "DeliveryConfirm",
//   DeliveryRating: "DeliveryRating",
//   AddDeliveryNote: "AddDeliveryNote",
//   ServiceApprove: "ServiceApprove",
//   Performance: "Performance",
//   PerformanceAdd: "PerformanceAdd",
//   PerformanceAppraisal: "PerformanceAppraisal",
//   HODApprove: "HODApprove",
//   ViewReports: "Report",
//   AddReports: "ReportAdd",
//   InternalControl: "InternalControl",
// };

export const DEFINED_PERMISSIONS = {
  BudgetWaiver: "BudgetWaiver",
  PUSH_PAYMENT: "PUSH_PAYMENT",
  ControlPayment: "ControlPayment",
  ControlPayment2: "ControlPayment2",
  PaymentLog: "PaymentLog",
  DownloadPayment: "DownloadPayment",
  FinancePayment: "FinancePayment",
  VendorPayment: "VendorPayment",
  DriverActivityAdmin: "DriverActivityAdmin",
  HMOClaims: "HMOClaims",
  HMOClaimsHOD: "HMOClaimsHOD",
  ApproveHMOClaimsEDOps: "ApproveHMOClaimsEDOps",
  ApproveHMOClaimsEDOFI: "ApproveHMOClaimsEDOFI",
  SeniorAppraisalOfficer: "SeniorAppraisalOfficer",
  ApproveHMOClaimsMD: "ApproveHMOClaimsMD",
  WeekendAllowance: "WeekendAllowance",
  WeekendAllowanceHOD: "WeekendAllowanceHOD",
  ApproveWeekendAllowanceEDOps: "ApproveWeekendAllowanceEDOps",
  ApproveWeekendAllowanceEDOFI: "ApproveWeekendAllowanceEDOFI",
  ApproveWeekendAllowanceMD: "ApproveWeekendAllowanceMD",
  EmployeePaymentRequisition: "EmployeePaymentRequisition",
  EmployeePaymentRequisitionHOD: "EmployeePaymentRequisitionHOD",
  ApproveEmployeePaymentRequisitionEDOps:
    "ApproveEmployeePaymentRequisitionEDOps",
  ApproveEmployeePaymentRequisitionEDOFI:
    "ApproveEmployeePaymentRequisitionEDOFI",
  ApproveEmployeePaymentRequisitionMD: "ApproveEmployeePaymentRequisitionMD",
  ViewAdminAndFinanceModule: "ViewAdminAndFinanceModule",
  VendorCreate: "VendorCreate",
  AssetView: "AssetView",
  Vendor: "Vendor",
  QuotationApprove: "QuotationApprove",
  VendorManager: "VendorManager",
  PrimaryVendorManager: "PrimaryVendorManager",
  AssetAdd: "AssetAdd",
  AssetApproval: "AssetApproval",
  Auditor: "Auditor",
  PermissionManager: "PermissionManager",
  SeniorVendorManager: "SeniorVendorManager",
  UserCreation: "UserCreation",
  AssetAcquisitionView: "AssetAcquisitionView",
  AssetAcquisitionAdd: "AssetAcquisitionAdd",
  AssetAcquisitionApprove: "AssetAcquisitionApprove",
  AssetAllocationAdd: "AssetAllocationAdd",
  AssetAllocationApprove: "AssetAllocationApprove",
  AssetAllocationView: "AssetAllocationView",
  AssetAuctionApprove: "AssetAuctionApprove",
  AssetAuctionAdd: "AssetAuctionAdd",
  AssetAuctionView: "AssetAuctionView",
  AssetBidView: "AssetBidView",
  AssetBidAdd: "AssetBidAdd",
  AssetBidApprove: "AssetBidApprove",
  AssetCategoryAdd: "AssetCategoryAdd",
  AssetCategoryApprove: "AssetCategoryApprove",
  AssetCategoryView: "AssetCategoryView",
  AssetComponentAdd: "AssetComponentAdd",
  AssetComponentView: "AssetComponentView",
  AssetMantainanceView: "AssetMantainanceView",
  AssetMaintainanceApproval: "AssetMaintainanceApproval",
  AssetMantainanceAdd: "AssetMantainanceAdd",
  AssetRequisitionApprove: "AssetRequisitionApprove",
  AssetRequisitionAdd: "AssetRequisitionAdd",
  AssetRequisitionView: "AssetRequisitionView",
  BudgetAdd: "BudgetAdd",
  BudgetView: "BudgetView",
  ConsumableView: "ConsumableView",
  ConsumableApprove: "ConsumableApprove",
  ConsumableAdd: "ConsumableAdd",
  ConsumableAllocationApprove: "ConsumableAllocationApprove",
  ConsumableAllocationAdd: "ConsumableAllocationAdd",
  ConsumableAllocationView: "ConsumableAllocationView",
  ConsumableRequisitionView: "ConsumableRequisitionView",
  ConsumableRequisitionApprove: "ConsumableRequisitionApprove",
  ConsumableRequisitionAdd: "ConsumableRequisitionAdd",
  ConsumableCategoryView: "ConsumableCategoryView",
  ConsumableCategoryApprove: "ConsumableCategoryApprove",
  ConsumableCategoryAdd: "ConsumableCategoryAdd",
  BusinessNature: "BusinessNature",
  SeniorProcurementManager: "SeniorProcurementManager",
  ProcurementRequisitionView: "ProcurementRequisitionView",
  ProcurementRequisitionAdd: "ProcurementRequisitionAdd",
  ProcurementRequisitionDashboard: "ProcurementRequisitionDashboard",
  QuotationDeliver: "QuotationDeliver",
  QuotationAdd: "QuotationAdd",
  DeliveryView: "DeliveryView",
  DeliveryApprove: "DeliveryApprove",
  DeliveryConfirm: "DeliveryConfirm",
  DeliveryRating: "DeliveryRating",
  AddDeliveryNote: "AddDeliveryNote",
  ServiceApprove: "ServiceApprove",
  Performance: "Performance",
  PerformanceAdd: "PerformanceAdd",
  PerformanceAppraisal: "PerformanceAppraisal",
  ReportAdd: "ReportAdd",
  Report: "Report",
  PrimaryFleetManager: "PrimaryFleetManager",
  SecondaryFleetManager: "SecondaryFleetManager",
  AuditView: "AuditView",
  HODApprove: "HODApprove",
  EDApprove: "EDApprove",
  EDOperationApprove: "EDOperationApprove",
  EDFinanceApprove: "EDFinanceApprove",
  HRApprove: "HRApprove",
  MDApprove: "MDApprove",
  Driver: "Driver",
  FuelPaymentDecline: "FuelPaymentDecline",
  Group: "Group",
  addGroup: "addGroup",
  addPermissionGroup: "addPermissionGroup",
  removePermissionGroup: "removePermissionGroup",
  SeniorStoreManager: "SeniorStoreManager",
  PrimaryProcurementManager: "PrimaryProcurementManager",
  ProcurementFinanceManager: "ProcurementFinanceManager",
  QuotationView: "QuotationView",
  ReportTrigger: "ReportTrigger",
  StoreManager: "StoreManager",
  InternalControl: "InternalControl",
  HRManager: "HRManager",
  Staff: "Staff",
  AuxiliaryServiceManager: "AuxiliaryServiceManager",
  SecondaryJobLister: "SecondaryJobLister",
  JobApplicants: "JobApplicants",
  PermanentStaff: "PermanentStaff",
  SeniorPayrollManager: "SeniorPayrollManager",
  HODFinance: "HODFinance",
  FinanceControlOfficer: "FinanceControlOfficer",
  PaymentServiceStakeholder: "PaymentServiceStakeholder",
  FinanceOfficer: "FinanceOfficer",
  CostCenterStakeholder: "CostCenterStakeholder",
  TreasuryOfficer: "TreasuryOfficer",
  SeniorFinanceOfficer: "SeniorFinanceOfficer",
  BudgetStakeholder: "BudgetStakeholder",
  CooperativeAdmin: "CooperativeAdmin",
  CooperativeReviewer: "CooperativeReviewer",
  CooperativeApprover: "CooperativeApprover",
  PayrollOfficer: "PayrollOfficer",
  CreateAccountLedger: "CreateAccountLedger",
  ViewAccountLedgerFinanceTransaction: "ViewAccountLedgerFinanceTransaction",
  ReverseAccountLedger: "ReverseAccountLedger",
  ApproveDeclineFinanceTransaction: "ApproveDeclineFinanceTransaction",
  ViewAllAccountLedger: "ViewAllAccountLedger",
  ReviewReversedAccountLedger: "ReviewReversedAccountLedger",
  UploadBankStatement: "UploadBankStatement",
  CreateAccountLedgerSetup: "CreateAccountLedgerSetup",
  UpdateAccountLedgerGroupSetup: "UpdateAccountLedgerGroupSetup",
  SeniorHRManager: "SeniorHRManager",
  PrimaryHRManager: "PrimaryHRManager",
  LineManager: "LineManager",
  JuniorAppraisalOfficer: "JuniorAppraisalOfficer",
  HOD: "HOD",
  HOU: "HOU",
  Applicant: "Applicant",
  CreateAccount: "CreateAccount",
  AccountApproval: "AccountApproval",
  ControlOfficierOne: "ControlOfficierOne",
  ControlOfficierTwo: "ControlOfficierTwo",
  BudgetImportApprover: "BudgetImportApprover",
};
